import React, { Component } from "react";
import { connect } from "react-redux";

class ScrollerItem extends Component {
  render() {
    const { themeColor, isSelected, flag, id } = this.props;
    return (
      <div
        style={{
          marginRight: 8,
          marginLeft: 8,
          justifySelf: "center",
          userSelect: "none",
          cursor: "pointer",
          opacity: isSelected ? 1 : 0.6,
          width: 80,
          height: 70,
          border: isSelected ? `2px solid ${themeColor}` : "1px solid #cecece",
          borderRadius: 4,
          display: "grid",
          alignItems: "center",
          justifyContent: "center",
        }}
        onClick={() => {
          this.props.setSelectedCountry(id);
        }}
      >
        {!!flag && (
          <img
            src={
              !flag.startsWith("http")
                ? "http://localhost:8000".concat(flag)
                : flag
            }
            style={{
              width: 24 * 1.3,
              height: 24 * 1.3,

              pointerEvents: "none",
            }}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    themeColor: state.store.store.settings.dark,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(ScrollerItem);
